import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { FormDialogContainerComponent } from '../containers/form-dialog-container/form-dialog-container.component';
import { FormDialogOptions } from '../models/form-dialog-options';

@Injectable({
  providedIn: 'root',
})
export class FormDialogService {
  constructor(private dialog: MatDialog) {}

  open<T>(options: FormDialogOptions, width: string = '560px'): Observable<T> {
    const dialogOption: MatDialogConfig<FormDialogOptions> = {
      width,
      disableClose: false,
      panelClass:
        options.currentThemeMode === 'dark'
          ? ['dark-theme', 'dialog', 'form-panel']
          : ['light-theme', 'dialog', 'form-panel'],
      autoFocus: false,
      data: options,
    };

    return this.dialog.open(FormDialogContainerComponent, dialogOption).beforeClosed();
  }
}
